define("shared/components/shared/button/media-uploader", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/internals", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _internals, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/internals",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes>
    <Shared::Ui::Button
      @additional={{@additional}}
      @class={{@buttonClass}}
      @isDisabled={{not this.canUpload}}
      @onClick={{this.handleClick}}
      @size={{@size}}
      @text={{@text}}
      @variant={{@variant}}
    />
    <Input
      @type="file"
      accept={{@accept}}
      class="u--hide"
      id={{this.inputId}}
      multiple={{gt @uploadLimit 1}}
      {{on "change" (perform this.handleFileChange)}}
    />
  </div>
  */
  {
    "id": "kNZRuIEW",
    "block": "[[[11,0],[17,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,2],[30,3],[28,[37,1],[[30,0,[\"canUpload\"]]],null],[30,0,[\"handleClick\"]],[30,4],[30,5],[30,6]]],null],[1,\"\\n  \"],[8,[39,2],[[16,\"accept\",[30,7]],[24,0,\"u--hide\"],[16,1,[30,0,[\"inputId\"]]],[16,\"multiple\",[28,[37,3],[[30,8],1],null]],[4,[38,4],[\"change\",[28,[37,5],[[30,0,[\"handleFileChange\"]]],null]],null]],[[\"@type\"],[\"file\"]],null],[1,\"\\n\"],[13]],[\"&attrs\",\"@additional\",\"@buttonClass\",\"@size\",\"@text\",\"@variant\",\"@accept\",\"@uploadLimit\"],false,[\"shared/ui/button\",\"not\",\"input\",\"gt\",\"on\",\"perform\"]]",
    "moduleName": "shared/components/shared/button/media-uploader.hbs",
    "isStrictMode": false
  });
  /**
   * This component is used to render a button that can be used to upload media files.
   * It uses the genericMediaManager service to upload file via S3.
   *
   * Arguments:
   * - [size] (String) Button Size, Options: "small", "regular", "large" (default: "regular")
   * - [variant] (String) Button color styling, Options: "actionLink", "primary", "default", "proceed", "outline", "danger", "mute", "unstyled" (default: "primary")
   * - [additional] (String) Button options, Available options: "rounded", "circle", "block" (default: null)
   * - [text] (String) The text displayed on the button.Required for inline usage. If this component is invoked as a block,
   *   the block contents will be used instead of this property. (default: "")
   * - [accept] (String) The file types that can be uploaded. (Example: ".jpeg, .jpg, .png")
   * - [attachmentType] (String) The type of attachment to be uploaded for model creation.
   * - [uploadLimit] (Number) The maximum number of files that can be uploaded. The uploader is disabled if this is 0.
   * - [onAttachmentUpload] (Function) A callback function that is called when an attachment finishes uploading.
   * - [onLengthError] (Function) Function to call if over upload limit, can be used to display limit information to user.
   *
   */
  let MediaUploaderComponent = _exports.default = (_class = class MediaUploaderComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "genericMediaManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _defineProperty(this, "inputId", `media-input-${(0, _internals.guidFor)(this)}`);
      _defineProperty(this, "handleFileChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          const {
            target
          } = event;
          const {
            files
          } = target;
          if (!files) {
            return;
          }
          if (files.length > this.args.uploadLimit && this.args.onLengthError) {
            this.args.onLengthError();
          }
          yield (0, _emberConcurrency.allSettled)(Array.from(files).slice(0, Math.min(files.length, this.args.uploadLimit)).map(file => this.uploadFile.perform(file)));
        }
      }), null, "handleFileChange", null));
      _defineProperty(this, "uploadFile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (file) {
          try {
            const attachment = yield this.genericMediaManager.uploadImage.perform(file, {
              attachmentType: this.args.attachmentType,
              setPreview: url => attachment.previewUrl = url
            });
            this.args.onAttachmentUpload(attachment);
          } catch (error) {
            this.errors.show(`${this.intl.t('influencers.campaigns.details.upload_inspiration_error')} ${file.name}`, error);
          }
        }
      }), {
        enqueue: true,
        maxConcurrency: 1
      }, "uploadFile", null));
    }
    get isUploading() {
      return this.uploadFile.isRunning;
    }
    get canUpload() {
      return this.args.uploadLimit > 0 && !this.isUploading;
    }
    handleClick(event) {
      event.preventDefault();
      document.getElementById(this.inputId)?.click();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "genericMediaManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaUploaderComponent);
});